var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAccess = function SvgAccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Access_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    stroke: "#022356",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M35 64.22A29.216 29.216 0 0 1 14.343 14.34a29.216 29.216 0 0 1 49.875 20.66A29.247 29.247 0 0 1 35 64.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Access_svg__b)",
    d: "M35 52.462a17.458 17.458 0 1 1 17.46-17.46A17.48 17.48 0 0 1 35 52.462"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    d: "m41.998 51.334-4.666.778H34.22l-2.334-.778a11.035 11.035 0 0 0-3.889-.778c-.622 0-1.037-1.295-1.555-1.555l-2.334-.778.778-1.556v-2.333c0-.778.778-1.556.778-2.334 0-.622 1.038-1.295 1.556-1.555a33.021 33.021 0 0 1 5.444-2.334 16.027 16.027 0 0 0 3.111-.777l2.333.777a25.08 25.08 0 0 1 5.445 2.334l2.333 2.333v5.445l-2.333 1.556-1.556 1.555"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M35 52.462a17.458 17.458 0 1 1 17.46-17.46A17.48 17.48 0 0 1 35 52.462ZM34.999 11.512V0M34.999 70.002V59.033M58.487 35h11.511M0 35h10.968"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    stroke: "#022356",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M39.774 30.582v1.089a4.773 4.773 0 1 1-9.547 0v-1.089a4.773 4.773 0 1 1 9.547 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M23.89 48.46v-3.952a5.375 5.375 0 0 1 3.4-4.997l7.708-3.047M34.999 36.464l7.709 3.047a5.376 5.376 0 0 1 3.4 5v3.951"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Access_svg__b",
    x1: 22.571,
    x2: 47.433,
    y1: 17.893,
    y2: 49.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Access_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h70v70H0z"
  })))));
};
export default SvgAccess;